import { axiosBasic } from "../config/axios-common";

const postInsertOrUpdatePhysicianRecommendation = async (data: any, professionalId: string) => {

  try {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      const response = await axiosBasic.post(`/sam/v1/physicianRecommendationData/insertOrUpdate/?professionalId=${encodeURIComponent(professionalId)}`, data, config);

      const responseData = await response.data;

      return responseData;

  } catch (e: any) {
      throw e;
  }
};



const exportedObject = {
    postInsertOrUpdatePhysicianRecommendation
};
  
  
  export default exportedObject